import { Injectable } from '@angular/core';

const SESSION_KEY = 'cockpit-date-filter-value';

/**
 * Persiste la période de date sélectionnée indépendamment de la colonne (`cat`) utilisée
 * dans les filtres GPS, pour la partager entre les différentes pages.
 *
 * La valeur stockée est la chaîne brute du filtre de date (ex: "01/01/2026 00:00:00|31/01/2026 23:59:59").
 * Chaque resolver mappe cette valeur vers sa propre colonne (`cat`).
 */
@Injectable({ providedIn: 'root' })
export class CockpitDateFilterStateService {
  getValue(): string | null {
    return sessionStorage.getItem(SESSION_KEY);
  }

  setValue(value: string): void {
    sessionStorage.setItem(SESSION_KEY, value);
  }

  /**
   * Supprime la valeur de date partagée entre les pages GPS
   */
  clearValue(): void {
    sessionStorage.removeItem(SESSION_KEY);
  }

  hasValue(): boolean {
    return sessionStorage.getItem(SESSION_KEY) !== null;
  }
}
